import React from 'react'
import ThemeArticle from './VyberTheme'
import { WrapperSlider, SlideTrack } from './StyledVyberSlider'

const Slider = ({ articles, utmParams, imageSize, handleGaEvent }) => {
  return (
    <WrapperSlider>
      <SlideTrack>
        {articles.map((article, index) =>
          <ThemeArticle
            key={index}
            index={index}
            article={article}
            utmParams={utmParams}
            imageSize={imageSize}
            handleGaEvent={handleGaEvent}
          />
        )}
      </SlideTrack>
    </WrapperSlider>
  )
}

export default Slider
